// Contrôle d'une réponse HTTP hors relais /cdp (Lambdas de synchronisation
// des badgeuses et des badges).
//
// `fetch` ne lève rien sur une réponse 4xx/5xx : sans contrôle de `res.ok`,
// une erreur s'affiche comme un succès. Les Lambdas répondent
// `{"error": true, "message": "..."}` : `message` passe donc avant `error`,
// et `error` n'est retenu que s'il s'agit d'une chaîne.

const nonEmptyString = (value) => {
  return typeof value === 'string' && value.trim() !== '' ? value : null;
};

// Message lisible d'une réponse en erreur : `message` ou `error` du corps
// JSON, sinon le texte brut, sinon `HTTP <status>`.
export const readErrorMessage = async (res) => {
  let text = '';
  try {
    text = await res.text();
  } catch (e) {
    text = '';
  }

  try {
    const body = JSON.parse(text);
    if (body && typeof body === 'object') {
      const message =
        nonEmptyString(body.message) || nonEmptyString(body.error);
      if (message) {
        return message;
      }
    }
  } catch (e) {
    // Corps non JSON : le texte brut sert de message.
  }

  return nonEmptyString(text) ? text.trim() : `HTTP ${res.status}`;
};

// Renvoie la réponse si elle est ok, lève sinon une Error portant son message.
export const ensureOk = async (res) => {
  if (!res.ok) {
    throw new Error(await readErrorMessage(res));
  }
  return res;
};
